/**
 * TanStack Query hook for fetching live casino categories and feature flag
 * 
 * OPTIMIZATION: This query now uses the unified /lobby/init endpoint via useLobbyInitQuery
 * which fetches categories, providers, live-categories, and jackpot data in a single request.
 */

import { useLobbyInitQuery } from './useLobbyInitQuery';

export interface LiveCategory {
  id: number;
  name: string;
  slug: string;
  description?: string;
  icon?: string;
  image_url?: string;
  display_order: number;
  game_count?: number;
}

export interface LiveCategoriesResult {
  categories: LiveCategory[];
  enabled: boolean;
}

/**
 * Fetch live casino categories and whether the Live Casino feature is enabled.
 * When disabled, categories is [] and enabled is false (players see no live games).
 * 
 * OPTIMIZATION: Uses the unified /lobby/init endpoint via useLobbyInitQuery to reduce API calls.
 */
export function useLiveCategoriesQuery() {
  const { data, isLoading, error, refetch } = useLobbyInitQuery();
  
  const enabled = data?.liveGamesEnabled !== false;
  const categories = enabled ? data?.liveCategories || [] : [];
  
  return {
    data: { categories, enabled } as LiveCategoriesResult,
    isLoading,
    error,
    refetch,
  };
}
